/** @file The user preference for the default tab on the submission page. */
import { exactly } from 'purify-ts/Codec';
import { expr } from '@codegrade/utils';
import { SiteSettingsStore, UIPrefsStore, UserStore } from '@/store';
/** The user preference for the default tab on the submission page. */
export var SubmissionTabPreset;
(function (SubmissionTabPreset) {
    /** The name of the preference in the database. */
    SubmissionTabPreset.PREF_NAME = 'submission_tab_preset';
    /** Parser for the allowed values of this preference. */
    SubmissionTabPreset.codec = exactly('smart', 'code', 'feedback-overview', 'auto-test', 'peer-feedback');
    /** @returns A promise that resolves once the preferred value has been loaded. */
    SubmissionTabPreset.load = () => UIPrefsStore.loadUIPreference({ preference: SubmissionTabPreset.PREF_NAME });
    /**
     * Update the preferred value for the current user.
     *
     * @param value The new value.
     * @returns A promise that resolves once the new value has been stored.
     */
    SubmissionTabPreset.set = (value) => UIPrefsStore.patchUIPreference({
        preference: SubmissionTabPreset.PREF_NAME,
        value,
    });
    /** @returns The default value of the preference for the logged in user. */
    function defaultValue() {
        const user = UserStore.loggedInUser();
        const tenantId = user.chain(u => u.tenantId);
        return SiteSettingsStore.getSetting()('DEFAULT_SUBMISSION_PAGE_TAB', tenantId);
    }
    /** @returns The value for the currently logged in user. */
    function get() {
        const pref = UIPrefsStore.getUIPref()(SubmissionTabPreset.PREF_NAME, SubmissionTabPreset.codec);
        return expr.match(pref, 'status', {
            'not-loaded': () => defaultValue(),
            'not-present': () => defaultValue(),
            'not-valid': () => defaultValue(),
            valid: ({ value }) => value,
        });
    }
    SubmissionTabPreset.get = get;
})(SubmissionTabPreset || (SubmissionTabPreset = {}));
